import * as React from 'react';
import { Layout } from '../Layout';
import * as styles from './Benefits.css';

interface IBenefitsProps {
  title: React.ReactNode;
  cards: React.ReactNode[];
}

export function Benefits({ title, cards }: IBenefitsProps) {
  return (
    <section id="benefits" className={styles['container']}>
      <Layout>
        <div className={styles['title']}>{title}</div>

        <ul className={styles['list']}>
          {React.Children.map(cards, (card, index) => (
            <li key={index} className={styles['item']}>
              {card}
            </li>
          ))}
        </ul>
      </Layout>
    </section>
  );
}
